export default "__VITE_ASSET__a8aea765__"